import React, { Component } from "react";
import { withRouter } from "react-router";
import { ReactComponent as DNAIcon } from "../assets/img/dna.svg";

class LoadDNA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  render() {
    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ margin: "0 auto", position: "relative", ...this.props }}>
          <DNAIcon />
        </div>
      </div>
    );
  }
}

export default withRouter(LoadDNA);
